module.exports = __webpack_public_path__ + "images/flag-denmark_c4ca5a90ee853e8558ad0876fa9aa0d8.svg";